export const predefinedPopularScreens = [
    {
        id: 'overbought-us',
        name: 'Overbought',
        category: 'technical',
        color: '#FF9800', // Amber (technical - overbought)
        filters: {
            rsiMoreThan: 70,
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    },
    {
        id: 'oversold-us',
        name: 'Oversold',
        category: 'technical',
        color: '#F57C00', // Darker orange (technical - oversold)
        filters: {
            rsiLowerThan: 30,
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    },
    {
        id: 'near-200sma',
        name: 'Near 200-Day SMA',
        category: 'technical',
        color: '#FFB74D', // Lighter amber (technical - SMA focus)
        filters: {
            averageType: '200',
            comparisonType: 'range',
            minPercentage: -1,
            maxPercentage: 1,
            marketCapMoreThan: 1000000000, // $1B+
            priceMoreThan: 5,
            avgVolumeMoreThan: 500000,
            exchange: ['NASDAQ', 'NYSE', 'AMEX'],
            isEtf: false
        }
    },
    {
        id: 'undervalued-large-caps',
        name: 'Large Cap Value',
        category: 'value',
        color: '#4CAF50', // Standard green (value - large cap)
        filters: {
            dcfDiffMoreThan: 20,
            marketCapMoreThan: 1000000000,
            peLowerThan: 15,
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    },
    {
        id: 'deep-value',
        name: 'Deep Value',
        category: 'value',
        color: '#388E3C', // Dark green (value - deep)
        filters: {
            dcfDiffMoreThan: 50,
            peLowerThan: 10,
            priceLowerThan: 20,
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    },
    {
        id: 'quality-value',
        name: 'Quality Value',
        category: 'value',
        color: '#66BB6A', // Light green (value - quality)
        filters: {
            dcfDiffMoreThan: 15,
            betaLowerThan: 1.2,
            marketCapMoreThan: 500000000,
            peLowerThan: 20,
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    },
    {
        id: 'high-beta-momentum',
        name: 'Momentum',
        category: 'growth',
        color: '#2196F3', // Blue (growth - momentum)
        filters: {
            betaMoreThan: 1.5,
            rsiMoreThan: 60,
            marketCapMoreThan: 100000000,
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    },
    {
        id: 'large-cap-leaders',
        name: 'Large Cap Leaders',
        category: 'growth',
        color: '#1976D2', // Dark blue (growth - leaders)
        filters: {
            averageType: '200',
            comparisonType: 'above',
            minPercentage: '0',
            marketCapMoreThan: 10000000000,
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    },
    {
        id: 'tech-value',
        name: 'Tech Value',
        category: 'sector',
        color: '#9C27B0', // Purple (sector - technology)
        filters: {
            dcfDiffMoreThan: 15,
            peLowerThan: 30,
            marketCapMoreThan: 1000000000,
            sector: 'Technology',
            exchange: ['NASDAQ', 'NYSE', 'AMEX']
        }
    }
];
